(function(){
    function Collection(){
        this.sidebar = null;
        this.orderPopup = null;
        this.filderOpened = false;
        this.init = function(){
            let self = this;
            this.sidebar = $('.collection-grid .col-filter');
            this.orderPopup = $('#list-sort');
            
            //gestione filtri
            $('.link-filter').on("click",function(){
                self.toggleSidebar();
            });
            
            $('.grid-filter-item-head').on("click",function(){
                self.toogleFilter($(this).parent());
            });

            $('.active-tag').on("click",function(){
                self.removeFilter($(this).attr('data-value'));
            })

            // Ordinamento
            $('.sort-value').on("click",function(){
                self.sortBy($(this).attr('data-value'));
            });
        };
        
        this.toggleSidebar = function(){
            console.log('toggleSideBar');
            if(this.sidebar.hasClass("open")){
                $("body").trigger("cos-toggleSidebar-clore-before");
                window.cosCookie.setValue('collection.filter.opened',"false");
                this.filderOpened=false;
                $('.link-filter').removeClass("open");
                this.sidebar.removeClass("open");
                $("body").trigger("cos-toggleSidebar-clore-after");
            }
            else{
                $("body").trigger("cos-toggleSidebar-open-before");

                window.cosCookie.setValue('collection.filter.opened',"true");
                this.filderOpened=true;
                $('.link-filter').addClass("open");
                this.sidebar.addClass("open");
                
                $("body").trigger("cos-toggleSidebar-open-after");
            }
        };

        this.toogleFilter = function(itm){
            if(itm.hasClass("open")){
                
                itm.removeClass("open");
                itm.find('.grid-filter-item-head .icon').html("+");
                itm.find('.grid-filter-item-content').slideUp();
                
            }else{
                itm.addClass("open");
                itm.find('.grid-filter-item-head .icon').html("-");
                itm.find('.grid-filter-item-content').slideDown({start: function () { $(this).css({display:'flex'})}});
            }
        };

        this.removeFilter = function(tag){
            let url = window.location.href;
            if(url.indexOf("+"+tag)>0){
                url = url.replace("+"+tag,"");
            } else {
                if(url.indexOf(tag+"+")>0){
                    url = url.replace(tag+"+","");
                }else{
                    url = url.replace(tag,"");
                }
            }
            window.location = url;
        };

        this.sortBy = function(value){
            const current = $('.collection-sorting').attr("data-current");
            if(current==value){
                return;
            }
            let url = window.location.href;
            if(current!=""){
                url = url.replace("sort_by="+current,"sort_by="+value);
            }else{
                let s = url.indexOf("?")>0?"&":"?";
                url+= s+"sort_by="+value;
            }
            window.location = url;
        }
    }
    
$(document).ready(function(){
    if($('.collection-page').length > 0){
        var c = new Collection();
        c.init();
    }
});


})();
/* Updated on: 11th Aug, 12:50:19 PM */